// Horizontal scroll-snap carousel. Arrow buttons target the host with commandfor and the
// --prev / --next commands; they scroll [data-carousel-track] by one item and are disabled at either end.
class SCarousel extends HTMLElement {
  #controller;

  connectedCallback() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    this.addEventListener('command', (event) => this.#onCommand(event), { signal });
    this.#track()?.addEventListener('scroll', () => this.#updateButtons(), { signal, passive: true });
    window.addEventListener('resize', () => this.#updateButtons(), { signal, passive: true });
    this.#updateButtons();
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }

  #track() {
    return this.querySelector('[data-carousel-track]');
  }

  #onCommand(event) {
    if (event.command !== '--next' && event.command !== '--prev') return;
    const track = this.#track();
    if (!track) return;
    const item = track.firstElementChild;
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    const step = (item ? item.getBoundingClientRect().width : track.clientWidth) + gap;
    const rtl = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
    const direction = event.command === '--next' ? 1 : -1;
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    track.scrollBy({ left: step * direction * rtl, behavior: reduce ? 'auto' : 'smooth' });
  }

  #updateButtons() {
    const track = this.#track();
    if (!track) return;
    const position = Math.abs(track.scrollLeft);
    const max = track.scrollWidth - track.clientWidth;
    const id = this.id;
    if (!id) return;
    document.querySelectorAll(`[commandfor="${CSS.escape(id)}"]`).forEach((button) => {
      if (button.getAttribute('command') === '--prev') button.disabled = position <= 2;
      if (button.getAttribute('command') === '--next') button.disabled = position >= max - 2;
    });
  }
}

if (!customElements.get('s-carousel')) customElements.define('s-carousel', SCarousel);
